import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import Slideshow from './Slideshow';
import Moviecard from './Moviecard';
import { ShimmerThumbnail } from "react-shimmer-effects";
import { Contextone } from './Context';
import { fetchBanner, fetchSectionList } from './Api';
import styled from 'styled-components';


const ShimmerContainer = styled.div`
  height: 230px;
  width: 178px;
  margin: 0 10px 30px 0;
  background: #3a3a3a;
  background-image: linear-gradient(to right, #3a3a3a 0%, #3f3f3f 10%, #4a4a4a 20%, #3f3f3f 30%, #3a3a3a 50%, #3a3a3a 100%);
  background-repeat: no-repeat;
  background-size: 1900px 800px;
  position: relative;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: shimmer;
  animation-timing-function: ease-in-out;

  @keyframes shimmer {
    0% {
      background-position: -400px 0;
    }
    100% {
      background-position: 400px 0;
    }
  }
`;

const ShimmerRow = () => (
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
        {[...Array(7)].map((_, index) => (
            <ShimmerContainer key={index} />
        ))}
    </div>
);

const LanguageData = () => {
    const { lid } = useParams();
    const countercontext = useContext(Contextone);
    const isurl = countercontext.isDomain;
    const apiUrl = `https://${isurl}`;
    
    const [sectionList, setSectionList] = useState([]);
    const [banner, setBanner] = useState([]);
    const [bannerData, setBannerData] = useState('');
    const [loading, setLoading] = useState(false);
    const [loadingMore, setLoadingMore] = useState(false);
    const [page, setPage] = useState(1);
    const [isPageUrl, setLastPageUrl] = useState("");

    useEffect(() => {
        setLoading(true);
        fetchData(1);
    }, [lid]);

    const fetchData = async (pageNum) => {
        if (loadingMore) return;

        try {
            setLoadingMore(true);
            
            const bannerData = await fetchBanner(apiUrl, countercontext.isTid, countercontext.isHomeId, lid);
            const sectionData = await fetchSectionList(apiUrl, countercontext.isTid, countercontext.isHomeId, pageNum, lid);

            const filteredBanner = bannerData.result.filter(item => ![3, 4, 6].includes(item.video_type));
            setBanner(filteredBanner);

            if (sectionData.status === 400) {
                setLastPageUrl(null);
                return;
            }
            
            setSectionList((prev) => [...prev, ...(sectionData.result.data || sectionData.result)]);
            setLastPageUrl(sectionData.next_page_url);

            if (sectionData.next_page_url) {
                setPage(pageNum + 1);
            }
        } catch (error) {
            console.error('Error:', error);
        } finally {
            setLoading(false);
            setLoadingMore(false);
        }
    };

    useEffect(() => {
        if (banner.length > 0) {
            setBannerData(banner[0].id);
        } else {
            setBannerData(null);
        }
    }, [banner]);

    const loadMoreData = () => {
        if (!loading && isPageUrl && !loadingMore) {
            fetchData(page);
        }
    };

    let isDataAvailable = 0;

    if (sectionList.length > 0) {
        sectionList.forEach((mtype) => {
            if (mtype.data && mtype.data.length > 0) {
                isDataAvailable = 1;
            }
        });
    }
    
    return (
        <>
            <div>
                {loading ? (
                    <div style={{ marginTop: "60px", width: "100vw", minWidth: "100vw" }}>
                        <div className="shimmer-container">
                            <ShimmerThumbnail className="shimmer-thumbnail" />
                        </div>
                        <Moviecard loading={true} />
                    </div>
                ) :   isDataAvailable == true ? (
                    <div className="home-body">
                        {bannerData && <Slideshow data={banner} bannervisible={true} />}
                        <Moviecard data={sectionList} bannervisible={!!bannerData} loading={false} type='lang' loadMoreData={loadMoreData} pageUrl={isPageUrl} />
                        {loadingMore && (
                            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                <ShimmerRow />
                            </div>
                        )}
                    </div>
                ) : bannerData && isDataAvailable == 0? (
                    <div className="home-body">
                        <Slideshow data={banner} bannervisible={true} />
                    </div>
                ): bannerData == null && isDataAvailable == 0 && (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '70vh', color: 'white' }}>
                        <h2>No data available</h2>
                    </div>
                )}
                
            </div>
        </>
    );
};

export default LanguageData;
